export const Tooltip = ({ children, label }) => {
    return (
      <div className="group/tip relative">
        {children}
        <div
          className="absolute left-full top-1/2 -translate-y-1/2 ml-3 px-3 py-1.5 rounded-lg text-xs font-semibold text-white whitespace-nowrap pointer-events-none opacity-0 group-hover/tip:opacity-100 transition-all duration-200 z-[9999]"
          style={{
            background: "rgba(15, 26, 46, 0.95)",
            border: "1px solid rgba(0, 180, 216, 0.25)",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(12px)",
          }}
        >
          {label}
          <div
            className="absolute right-full top-1/2 -translate-y-1/2"
            style={{
              width: 0, height: 0,
              borderTop: "5px solid transparent",
              borderBottom: "5px solid transparent",
              borderRight: "5px solid rgba(0, 180, 216, 0.25)",
            }}
          />
        </div>
      </div>
    );
  }